import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-footer" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "info-grid" }
const _hoisted_4 = { class: "info-section" }
const _hoisted_5 = { class: "info-section" }
const _hoisted_6 = { class: "info-section" }
const _hoisted_7 = { class: "features-content" }
const _hoisted_8 = { class: "feature-item" }
const _hoisted_9 = { class: "icon-wrapper" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "feature-item" }
const _hoisted_12 = { class: "icon-wrapper" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "feature-item" }
const _hoisted_15 = { class: "icon-wrapper" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "feature-item" }
const _hoisted_18 = { class: "icon-wrapper" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "footer-bottom" }
const _hoisted_21 = { class: "footer-bottom-container" }
const _hoisted_22 = { class: "footer-bottom-version" }

import { computed } from 'vue'

import { useTheme } from '@/composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AppFooter'
},
  __name: 'AppFooter',
  setup(__props) {



const { getAssetPath } = useTheme()

const footerDraws = computed(() => getAssetPath('footer', 'draws') || '/img/images/footer/01-draws.png')
const footerGlobalLotteries = computed(() => getAssetPath('footer', 'globalLotteries') || '/img/images/footer/02-global-lotteries.png')
const footerGreatMarkets = computed(() => getAssetPath('footer', 'greatMarkets') || '/img/images/footer/03-great-markets.png')
const footerFastResults = computed(() => getAssetPath('footer', 'fastResults') || '/img/images/footer/04-fast-results.png')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('footer.selectYourDraw')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.selectYourDrawText')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('footer.chooseYourNumber')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.chooseYourNumberText')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('footer.submitYourBet')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('footer.submitYourBetText')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: footerDraws.value,
              alt: "Fast",
              width: "60",
              height: "60"
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('footer.widestSelection')), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              src: footerGlobalLotteries.value,
              alt: "Lucky Numbers",
              width: "60",
              height: "60"
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('footer.globalLuckyNumbers')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: footerGreatMarkets.value,
              alt: "Great Markets",
              width: "60",
              height: "60"
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('footer.greatMarkets')), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("img", {
              src: footerFastResults.value,
              alt: "Fast Results",
              width: "60",
              height: "60"
            }, null, 8, _hoisted_19)
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('footer.fastResults')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_router_link, {
          to: "/terms-and-conditions",
          class: "footer-bottom-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.termsAndConditions')), 1)
          ]),
          _: 1
        }),
        _cache[0] || (_cache[0] = _createTextVNode(" | ")),
        _createVNode(_component_router_link, {
          to: "/wagers",
          class: "footer-bottom-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.wagers')), 1)
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createTextVNode(" | ")),
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('common.version')) + ": 1.0.1", 1)
      ])
    ])
  ]))
}
}

})